import { Grid, useMediaQuery } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { ChipField, Labeled, ReferenceArrayField, SimpleShowLayout, SingleFieldList } from "react-admin";

const DocumentsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Документи"
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Labeled label=" ">
            <ReferenceArrayField
              source="documentTypeIds"
              reference={administrationRequests.getPreferenceDocumentTypesSelect()}
            >
              <SingleFieldList
                linkType={false}
                empty={"Няма избрани документи"}
              >
                <ChipField source="name" />
              </SingleFieldList>
            </ReferenceArrayField>
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default DocumentsSection;
